// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__nl92r","header":"Menu_header__nj64c","body":"Menu_body__u9Dv5"};